var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('grid',{attrs:{"controllers":"true","titles":_vm.titles,"data":_vm.contents,"current-sort":"Mes","search-key":"DESCRICAO"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }